import { render, staticRenderFns } from "./qRCode.vue?vue&type=template&id=81682220&scoped=true&"
import script from "./qRCode.vue?vue&type=script&lang=js&"
export * from "./qRCode.vue?vue&type=script&lang=js&"
import style0 from "./qRCode.vue?vue&type=style&index=0&id=81682220&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81682220",
  null
  
)

export default component.exports